import { SvgFactory } from '../../Svg';

const MicroPhoneIcon = SvgFactory(
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='black'>
        <path d='M23.998 29C27.318 29 29.998 26.32 29.998 23V11C29.998 7.68 27.318 5 23.998 5C20.678 5 17.998 7.68 17.998 11V23C17.998 26.32 20.678 29 23.998 29ZM35.818 23C34.838 23 34.018 23.72 33.858 24.7C33.038 29.4 28.938 33 23.998 33C19.058 33 14.958 29.4 14.138 24.7C13.978 23.72 13.158 23 12.178 23C10.958 23 9.99802 24.08 10.178 25.28C11.158 31.28 15.958 35.98 21.998 36.84V41C21.998 42.1 22.898 43 23.998 43C25.098 43 25.998 42.1 25.998 41V36.84C32.038 35.98 36.838 31.28 37.818 25.28C38.018 24.08 37.038 23 35.818 23Z' />
    </svg>,
);

export default MicroPhoneIcon;
